import { render, staticRenderFns } from "./todayOrders.vue?vue&type=template&id=f10f8570&scoped=true&"
import script from "./todayOrders.vue?vue&type=script&lang=js&"
export * from "./todayOrders.vue?vue&type=script&lang=js&"
import style0 from "./todayOrders.vue?vue&type=style&index=0&id=f10f8570&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10f8570",
  null
  
)

export default component.exports